import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const UserDropdown = ({ value, onChange, userList, isLoading, placeholder, className = 'w-full', disabled = false }) => {
    const { th } = useLanguage();

    const userOptions =
        userList?.map((user) => {
            const displayText = user.email || th('systemAdministrator.noEmail');

            return {
                label: displayText,
                value: user.id,
                fullName: user.fullName || (user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : null) || user.userName || user.name || th('systemAdministrator.unnamedUser'),
                email: user.email || '',
                userId: user.id,
                user: user
            };
        }) || [];

    const selectedTemplate = (option) => {
        if (option) {
            return option.email || th('systemAdministrator.noEmail');
        }
        return placeholder || th('systemAdministrator.userPlaceholder');
    };

    const itemTemplate = (option) => {
        return (
            <div className="flex align-items-center p-2">
                <div className="flex flex-column">
                    <span className="font-medium">
                        <i className="pi pi-envelope mr-2"></i>
                        {option.email || th('systemAdministrator.noEmail')}
                    </span>
                    <small className="text-500 mt-1">{option.fullName}</small>
                </div>
            </div>
        );
    };

    const dropdownProps = {
        value: value,
        options: userOptions,
        onChange: (e) => onChange(e.value),
        placeholder: placeholder || th('systemAdministrator.userPlaceholder'),
        className: className,
        disabled: disabled || isLoading,
        filter: true,
        filterBy: 'label,fullName',
        showClear: true,
        emptyMessage: th('systemAdministrator.userEmptyMessage'),
        emptyFilterMessage: th('systemAdministrator.userEmptyFilterMessage'),
        itemTemplate: itemTemplate,
        valueTemplate: selectedTemplate,
        optionLabel: 'label',
        optionValue: 'value',
        panelClassName: 'user-dropdown-panel',
        filterPlaceholder: th('systemAdministrator.userSearchPlaceholder'),
        appendTo: typeof window !== 'undefined' ? document.body : null,
        scrollHeight: '300px'
    };

    if (isLoading) {
        return (
            <div className="p-dropdown p-component p-disabled w-full">
                <span className="p-dropdown-label p-inputtext">
                    <i className="pi pi-spinner pi-spin mr-2"></i>
                    {th('common.loading')}
                </span>
            </div>
        );
    }

    return <Dropdown {...dropdownProps} />;
};

export default UserDropdown;
